"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _get = _interopRequireDefault(require("lodash/get"));
var _reactRedux = require("react-redux");
var _reactRouterDom = require("react-router-dom");
var _config = _interopRequireDefault(require("../config"));
var _analytics = require("../modules/analytics");
var _analytics2 = require("../redux/analytics");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var trackLastActiveTarget = function trackLastActiveTarget(target) {
  if (window && window._analytics) {
    window._analytics.lastActiveTarget = target;
  }
};
function dispatchEvent() {
  if (!window._analytics && !window._analytics.nuiDispatchEvent) {
    return;
  }
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  return window._analytics.nuiDispatchEvent.apply(window._analytics.nuiDispatchEvent, args);
}
var Analytics = function Analytics(props) {
  var baseUrl = props.baseUrl,
    state = props.state,
    analyticsParams = props.analyticsParams,
    _props$dispatchPagevi = props.dispatchPageviewEvent,
    dispatchPageviewEvent = _props$dispatchPagevi === void 0 ? true : _props$dispatchPagevi,
    _props$getAppDimensio = props.getAppDimensionsForAnalytics,
    getAppDimensionsForAnalytics = _props$getAppDimensio === void 0 ? function () {
      return {};
    } : _props$getAppDimensio,
    _props$getCoreDataFor = props.getCoreDataForAnalytics,
    getCoreDataForAnalytics = _props$getCoreDataFor === void 0 ? function () {
      return {};
    } : _props$getCoreDataFor;
  var latestUrl;
  var location = (0, _reactRouterDom.useLocation)();
  function pageview() {
    var location = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    if (dispatchPageviewEvent === false) {
      return;
    }
    var path = location.pathname + location.search;
    if (latestUrl === path) {
      return;
    }
    latestUrl = path;
    var analyticsMeta = (0, _analytics2.pageviewEvent)({
      appDimensions: getAppDimensionsForAnalytics(state)
    }, getCoreDataForAnalytics(state));

    // wait for correct title
    setTimeout(function () {
      dispatchEvent(document, 'virtual.pageview', [], analyticsMeta, state);
    }, 0);
  }

  // useEffect will run every time location changes
  (0, _react.useEffect)(function () {
    var settings = (0, _get.default)(state, 'analytics', {
      initialSet: {}
    });
    var enabled = _config.default.nui.analytics.enabled;

    // no analytics?
    if (!settings.initialSet || settings.initialSet.userId === null || !enabled) {
      return;
    }
    var mutatedSettings = _objectSpread(_objectSpread({}, settings), {}, {
      initialSet: _objectSpread(_objectSpread({}, settings.initialSet), {}, {
        dimension1: baseUrl.replace('/', '').replace('/', '-')
      })
    });

    // now are we using analytics full version or short ping version?
    if (!settings.useSingleBeacon) {
      (0, _analytics.initGtmAnalytics)(mutatedSettings, window, document, location, analyticsParams);
    } else {
      (0, _analytics.initSingleBeaconAnalytics)(mutatedSettings, window, document, location, analyticsParams);
    }
    document && document.addEventListener('click', function (event) {
      trackLastActiveTarget(event.target);
    });
    window && window.addEventListener('keypress', function (event) {
      trackLastActiveTarget(event.target);
    });
    location && pageview(location);

    // Cleanup global listeners after this effect
    return function cleanup() {
      if (document && document.removeListener) {
        document.removeListener('click', trackLastActiveTarget);
      }
      if (window && window.removeListener) {
        window.removeListener('keypress', trackLastActiveTarget);
      }
    };
  }, [location]);
  return null;
};
Analytics.propTypes = {
  baseUrl: _propTypes.default.string.isRequired,
  history: _propTypes.default.object,
  analyticsParams: _propTypes.default.object,
  dispatchPageviewEvent: _propTypes.default.bool,
  initGtmAnalytics: _propTypes.default.func,
  initSingleBeaconAnalytics: _propTypes.default.func,
  getAppDimensionsForAnalytics: _propTypes.default.func,
  getCoreDataForAnalytics: _propTypes.default.func,
  state: _propTypes.default.object
};
var _default = exports.default = (0, _reactRedux.connect)(function (state) {
  return {
    state: state
  };
}, {})(Analytics);